import { Select } from "antd";
import { DefaultOptionType } from "antd/lib/select";
import UserTag from "components/user-tag/user-tag";
import { AcceptanceStatus } from "constants/index";
import { useProjectParticipants } from "hooks/project-participants";
import { useState, useEffect } from "react";

const { Option } = Select;

function DesignReviewerDropdown(props: {
  value?: any;
  notFoundContent?: any;
  onChange?:
    | ((value: any, option?: DefaultOptionType | DefaultOptionType[]) => void)
    | undefined;
  disabled?: boolean;
  defaultOpen?: boolean;
}) {
  const {
    value,
    notFoundContent,
    onChange,
    disabled = false,
    defaultOpen = false
  } = props;
  const { projectParticipants } = useProjectParticipants();
  const dataLoaded = projectParticipants?.dataLoaded;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (defaultOpen && dataLoaded) {
      setOpen(true);
    }
  }, [defaultOpen, dataLoaded]);
  const designReviewers = projectParticipants?.designReviewers?.filter(
    (user: any) => {
      const userId = value;
      if (userId && userId === user.id) {
        return true;
      }
      return user.status_id !== AcceptanceStatus.DEACTIVATED;
    }
  );

  return (
    <Select
      className="w-full"
      loading={!dataLoaded}
      value={designReviewers?.length > 0 ? value || undefined : undefined}
      onChange={onChange}
      showSearch
      allowClear
      filterOption
      optionFilterProp="label"
      notFoundContent={notFoundContent}
      disabled={disabled}
      // antd v6 renders the Option's children as the *selected* value, so the
      // company sub-line ended up inside the closed Select (v5 clipped it to a
      // single line). Point the selected value at a name-only node; the
      // dropdown list still renders the children, sub-line included.
      optionLabelProp="selectedLabel"
      {...(defaultOpen && { open, onOpenChange: setOpen })}
    >
      {(designReviewers ?? []).map((user: any) => {
        if (
          // left side is always a boolean (&& of two comparisons), so the ?? "" fallback is dead
          /* v8 ignore start */
          (user.status_id === AcceptanceStatus.DEACTIVATED &&
            user.id !== value?.toString()) ??
          ""
          /* v8 ignore stop */
        )
          return "";

        const selectedAndInactive =
          // left side is always a boolean (&& of two comparisons), so the ?? "" fallback is dead
          /* v8 ignore start */
          (user.status_id === AcceptanceStatus.DEACTIVATED &&
            user.id === value?.toString()) ??
          "";
        /* v8 ignore stop */

        const inactiveTag = user.status_id === AcceptanceStatus.DEACTIVATED && (
          <div className="absolute flex w-full items-center justify-end pr-3 -mt-[1px]">
            <UserTag label="Inactive" />
          </div>
        );

        return (
          <Option
            key={user.id}
            value={user.id}
            label={`${user.first_name} ${user.last_name} ${user?.company?.name}`}
            selectedLabel={
              <>
                {inactiveTag}
                {user.first_name} {user.last_name}
              </>
            }
            className={selectedAndInactive ? "hidden" : ""}
            firstName={user.first_name}
            lastName={user.last_name}
            company={user?.company}
          >
            {inactiveTag}
            <div>
              {user.first_name} {user.last_name}
            </div>
            <div className="text-sm text-gray-500">{user?.company?.name}</div>
          </Option>
        );
      })}
    </Select>
  );
}

export default DesignReviewerDropdown;
